import { PageBankAccountsACHPositivePay } from './ACHPositivePay';
import { PageBankAccountsDocuments } from './Documents';
import { PageBankAccountsEdit } from './Edit';
import { PageBankAccountsInterestPayoutView } from './InterestPayout/View';
import { PageBankAccounts } from './Overview';
import { PageBankAccountsPaymentAddresses } from './PaymentAddresses';
import { PageBankAccountSection } from './Section';
import { PageBankAccountsStatements } from './Statements';
import { PageBankAccountsTransfers } from './Transfers';

export const BANK_ACCOUNTS = {
  BankAccounts: PageBankAccounts,
  BankAccountSection: PageBankAccountSection,
  BankAccountsACHPositivePay: PageBankAccountsACHPositivePay,
  BankAccountsEdit: PageBankAccountsEdit,
  BankAccountsTransfers: PageBankAccountsTransfers,
  BankAccountsStatements: PageBankAccountsStatements,
  BankAccountsPaymentAddresses: PageBankAccountsPaymentAddresses,
  BankAccountsDocuments: PageBankAccountsDocuments,
  BankAccountsInterestPayoutView: PageBankAccountsInterestPayoutView,
} as const;
